import { render, staticRenderFns } from "./SignUpResult.vue?vue&type=template&id=3d4c4614"
import script from "./SignUpResult.vue?vue&type=script&lang=js"
export * from "./SignUpResult.vue?vue&type=script&lang=js"
import style0 from "./SignUpResult.vue?vue&type=style&index=0&id=3d4c4614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports